module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_PROTE PU_deskstop.d127824a.jpg";